import React from 'react';
import { JsonInput } from "react-admin-json-view";

import {
  ChipField,
  Create,
  Datagrid,
  DeleteButton,
  Edit,
  EditButton,
  List,
  NumberInput,
  ReferenceField,
  SimpleForm,
  TextField,
  TextInput,
} from 'react-admin';

const reportTemplateFilters = [
  <TextInput source="name__like" label="Name" alwaysOn/>,
  <TextInput source="template__like" label="Template"/>,
];

export const ReportTemplateList = props => (
  <List {...props} filters={reportTemplateFilters}>
    <Datagrid rowClick="edit">
      <TextField source="id"/>
      <TextField source="name"/>
      <ReferenceField label="Company" reference="Company" source="company.id" link="show">
        <ChipField source="name"/>
      </ReferenceField>
      <EditButton/>
      <DeleteButton/>
    </Datagrid>
  </List>
);

const ReportTemplateTitle = ({ record }) => {
  return <span>Report{record ? `: "${record.name}"` : ''}</span>;
};

export const ReportTemplateEdit = props => (
  <Edit title={<ReportTemplateTitle/>} {...props}>
    <SimpleForm>
      <ReferenceField label="Company" reference="Company" source="company.id" link="show">
        <ChipField source="name"/>
      </ReferenceField>
      <TextInput disabled source="id"/>
      <TextInput source="name"/>
      <TextInput source="company.id" label="Company ID"/>
      <JsonInput
        source="template"
        jsonString={true} // Set to true if the value is a string, default: false
        reactJsonOptions={{
          // Props passed to react-json-view
          name: null,
          collapsed: true,
          enableClipboard: true,
          displayDataTypes: false,
        }}
      />
      <TextInput multiline source="template" />
    </SimpleForm>
  </Edit>
);

export const ReportTemplateCreate = props => (
  <Create title='Create Report' {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <NumberInput source="company_id" label="Company ID" />
      <JsonInput
        source="template"
        jsonString={true} // Set to true if the value is a string, default: false
        reactJsonOptions={{
          // Props passed to react-json-view
          name: null,
          collapsed: true,
          enableClipboard: true,
          displayDataTypes: false,
        }}
      />
      <TextInput multiline source="template" />
    </SimpleForm>
  </Create>
);

